<template>
  <div v-bind:id="url" class="pa-0 mt-2 ma-0"></div>
</template>

<script>
import Player from "@vimeo/player";
export default {
  name: "Vimeo",
  mounted() {
    this.loadVideo();
  },
  methods: {
    loadVideo() {
      const isValidVideo =
        document.getElementById(this.url) &&
        this._validURL(this.url) &&
        this.url.includes("player.vimeo.com/video");
      if (isValidVideo) {
        let ifrm = document.createElement("iframe");
        ifrm.setAttribute("src", `${this.url}?texttrack=pt`);
        ifrm.setAttribute("id", `iframe-${this.url}`);
        ifrm.setAttribute("allowfullscreen", "");
        ifrm.setAttribute("allow", "autoplay; encrypted-media");
        ifrm.setAttribute("frameborder", "0");
        ifrm.setAttribute(
          "width",
          (
            document.getElementById("vetalfa-general-tab") ||
            document.getElementById("vetalfa-vimeo-player")
          ).clientWidth
        );
        ifrm.setAttribute(
          "height",
          (
            document.getElementById("vetalfa-general-tab") ||
            document.getElementById("vetalfa-vimeo-player")
          ).clientWidth * 0.6
        );
        document.getElementById(this.url).appendChild(ifrm);
        const player = new Player(ifrm);
        player.setLoop(false);
      }
    },
  },
  watch: {
    url() {
      this.loadVideo();
    },
  },
  props: {
    url: {
      type: String,
      required: true,
      default: "",
    },
    parentNodeId: {
      type: String,
      required: false,
      default: "vetalfa-general-tab",
    },
  },
};
</script>
